import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { tap } from "rxjs/operators";
import { CognitoAttributes } from "src/app/shared/enum/cognito.enum";

import { InvestorType, UserType } from "src/app/shared/enum/investor-type.enum";
import { showError, showErrorViaArray, showSucess } from "src/app/shared/utils/functions/notification.function";
import { encryptStorage } from "../../utils/storage";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { CadastroService } from "../../services/cadastro.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { PerfilService } from "src/app/portal/services/perfil.service";
import Swal from "sweetalert2";
import { Empresa, Representantes } from "../../models/empresa.model";
import { cnpjValidator, emailValidator, validateTelOrCell } from "src/app/shared/utils/validators/forms.validators";
import { Entidade } from "../../models/entidade.model";
import { IUsuarioEmpresa } from "src/app/portal/models/perfil.model";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { CnpjValidator } from "src/app/shared/utils/validators/cnpj-validator";
import { safeAsign } from "src/app/shared/utils/functions/safe-asign.function";

const USER_TYPE_MAP: Record<InvestorType, UserType> = {
  [InvestorType.PF]: UserType.InvestmentPf,
  [InvestorType.PJ]: UserType.InvestmentPj,
  [InvestorType.Investment]: UserType.InvestmentFund,
  [InvestorType.Entity]: UserType.Entity,
};

@Component({
  selector: 'app-complemento-cadastro',
  templateUrl: './complemento-cadastro.component.html',
  styleUrls: ['./complemento-cadastro.component.scss'],
})
export class ComplementoCadastroComponent implements OnInit {
  hasForm = false;
  isEntidade = false;
  isEmpresa = false;
  typeForm: InvestorType;
  usuario: IUsuarioEmpresa = new IUsuarioEmpresa();

  formEmpresa: FormGroup;
  formEntity: FormGroup;
  tableDdi: any[] = [];

  constructor(
    private cognitoService: CognitoService,
    private cadastroService: CadastroService,
    private perfilService: PerfilService,
    private router: Router,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.usuario.documentoIdentificador = encryptStorage.getItem("@documentoIdentificador", false);

    this.createArrayEmpresas([]);
    this.createFormEntidade(new Entidade());

  }

  onTipoSelecionado(typeForm: InvestorType) {
    this.typeForm = typeForm;

    if (typeForm === InvestorType.PF) {
      this.finalizarPF();
      return;
    }

    if (typeForm === InvestorType.PJ || typeForm === InvestorType.Investment) {
      this.verificaEmpresas();
      return;
    }

    if (typeForm === InvestorType.Entity) {
      this.carregaEntidade();
      return;
    }
  }

  voltarInicio() {
    this.location.back();
  }

  onVoltar() {
    this.hasForm = false;
    this.isEntidade = false;
    this.isEmpresa = false;
    this.typeForm = undefined;
  }

  private finalizarPF() {
    this.setaUserType(InvestorType.PF).subscribe(
      () => this.concluir(),
      (e) => showError('', e?.message || 'Erro ao salvar perfil.')
    );
  }

  private verificaEmpresas() {
    this.perfilService.listarEmpresas(this.usuario.documentoIdentificador).subscribe(
      (res) => {
        const empresas = res?.data ?? [];
        if (empresas.length > 0) {
          this.setaUserType(this.typeForm).subscribe(
            () =>
              Swal.fire({
                title: 'Perfil Pessoa Jurídica/Fundo de Investimento selecionado',
                html: 'Serão exibidas as garantias das empresas já cadastradas.<br> Para cadastrar uma nova empresa ou editar os dados de uma empresa existente, acesse a tela <b>Meu Perfil</b>.',
                icon: 'info',
                confirmButtonText: 'OK'
              }).then(
                () =>
                  this.cognitoService.refreshToken().subscribe(() => {
                  this.router.navigate(['spg/home-dpge']);
                })
              ),
            (e) => showError('', e?.message || 'Erro ao salvar perfil.')
          );
        } else {
          this.hasForm = true;
          this.isEmpresa = true;
        }
      },
      (e) => showError('', e?.message || 'Erro ao verificar empresas cadastradas.')
    );
  }

  private carregaEntidade() {
    this.cognitoService.getUserAttributes().subscribe(
      (attrs) => {
        const ddi = attrs[CognitoAttributes.DDINumber] || '';
        const semDdi = (v: string) => v && ddi && v.startsWith(ddi) ? v.slice(ddi.length) : v || '';

        this.formEntity.patchValue({
          tipoEntidade: attrs[CognitoAttributes.TypeEntity] || '',
          documentoIdentificador: attrs[CognitoAttributes.Cnpj] || '',
          razaoSocial: attrs[CognitoAttributes.ContactName] || '',
          codigoDdi: ddi,
          telefone: semDdi(attrs[CognitoAttributes.PhoneNumber] || ''),
          celular: semDdi(attrs[CognitoAttributes.CellNumber] || ''),
        });

        this.hasForm = true;
        this.isEntidade = true;
      },
      () => {
        this.hasForm = true;
        this.isEntidade = true;
      }
    )
  }

  cadastrarEmpresas() {
    if (this.validateFormEmpresa()) {
      const body = {
        documentoIdentificador: this.usuario.documentoIdentificador,
        empresas: this.formEmpresa.getRawValue().empresas.map((emp) => ({
          cnpj: emp.cnpj,
          nomeEmpresa: emp.nomeEmpresa,
          representantes: emp.representantes.map((rep) => ({
            nome: rep.nome,
            cpf: rep.cpf,
            emailPj: rep.emailPj,
          })),
        })),
      };

      this.setaUserType(this.typeForm).subscribe(
        () =>
          this.cadastroService.efetuarCadastroEmpresas(body).subscribe(
            () => this.concluir(),
            (e) => {
              if (e) {
                const errors = e?.error?.descricaoErro || [];
                return showErrorViaArray("", errors);
              } else {
                return showError(
                  "",
                  "Erro ao cadastrar empresa."
                );
              }
            }
          ),
        () => {
          showError('', 'Erro ao salvar perfil.');
        }
      );
    }
  }

  cadastrarEntidade() {
    if (this.validateFormEntidade()) {
      const {
        documentoIdentificador,
        razaoSocial,
        codigoDdi,
        telefone,
        celular,
        tipoEntidade
      } =  this.formEntity.getRawValue();

      this.cognitoService
        .update({
          'custom:user_type': USER_TYPE_MAP[InvestorType.Entity],
          [CognitoAttributes.ContactName]: razaoSocial,
          [CognitoAttributes.DDINumber]: codigoDdi,
          [CognitoAttributes.PhoneNumber]: telefone ? `${codigoDdi}${telefone}` : '',
          [CognitoAttributes.CellNumber]: celular ? `${codigoDdi}${celular}` : '',
          [CognitoAttributes.TypeEntity]: tipoEntidade,
          [CognitoAttributes.Cnpj]: documentoIdentificador,
        })
        .subscribe(
          () => {
            encryptStorage.setItem('@tipoUsuario', USER_TYPE_MAP[InvestorType.Entity], false);
            this.concluir();
          },
          (e) => {
              if (e) {
                const errors = e?.error?.descricaoErro || [];
                return showErrorViaArray("", errors);
              } else {
                return showError('', 'Erro ao cadastrar entidade.');
              }
            }

        );
    }
  }

  private setaUserType(tipo: InvestorType): Observable<any> {
    const userType = USER_TYPE_MAP[tipo];
    return this.cognitoService
      .update({ 'custom:user_type': userType })
      .pipe(tap(() => encryptStorage.setItem('@tipoUsuario', userType, false)));
  }

  private concluir() {
    this.cognitoService.refreshToken().subscribe(() => {
      showSucess('', 'Perfil vinculado com sucesso.');
      this.router.navigate(['/spg/home-dpge']);
    });
  }

  private createFormEntidade(entity: Entidade) {
    this.formEntity = new FormGroup(
      {
        tipoEntidade: new FormControl(entity.tipoEntidade || "", [
          Validators.required,
        ]),
        documentoIdentificador: new FormControl(
          entity.documentoIdentificador || "",
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(14),
            cnpjValidator,
          ]
        ),
        razaoSocial: new FormControl(entity.razaoSocial || "", [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(150),
          Validators.pattern(/^[^!"?\[\\\]‘’“”«»–.]*$/),
        ]),
        codigoDdi: new FormControl(entity.codigoDdi || "", [
          Validators.required,
        ]),
        telefone: new FormControl(entity.telefone || "", [
          Validators.minLength(10),
        ]),
        celular: new FormControl(entity.celular || "", [
          Validators.minLength(11),
        ]),
      },
      {
        validators: [validateTelOrCell],
      }
    );
  }

  private createArrayEmpresas(empresas: Empresa[]) {
    if (empresas && empresas.length > 0) {
      empresas.forEach((empresa) => {
        this.empresas.push(this.novaEmpresa(empresa));
      });
    }

    this.formEmpresa = new FormGroup({
      empresas: new FormArray([this.novaEmpresa()]),
    });
  }

  get empresas(): FormArray {
    return this.formEmpresa.get('empresas') as FormArray;
  }

  private novaEmpresa(empresa?: Empresa, remove?: boolean) {
    return new FormGroup({
      remove: new FormControl(remove),
      cnpj: new FormControl(empresa?.cnpj || "", [
        Validators.required,
        Validators.minLength(14),
        Validators.maxLength(18),
      ]),
      nomeEmpresa: new FormControl(empresa?.nomeEmpresa || "", [
        Validators.required,
        Validators.pattern(/^[^!"?\[\\\]‘’“”«»–.]*$/),
      ]),
      representantes: new FormArray([
        this.novoRepresentante(empresa?.representantes?.[0], true),
        this.novoRepresentante(empresa?.representantes?.[1], false),
      ]),
    });
  }

  private novoRepresentante(representante?: Representantes, isRequired = true) {
    const validarNome = isRequired ? [Validators.required, Validators.minLength(3)] : [Validators.minLength(3)];
    const validarCpf = isRequired ? [Validators.required, Validators.minLength(11), Validators.maxLength(14)] : [Validators.minLength(11), Validators.maxLength(14)];
    const validarEmail = isRequired ? [Validators.required, Validators.maxLength(50), emailValidator] : [Validators.maxLength(50), emailValidator];

    return new FormGroup({
      nome: new FormControl(representante?.nome || "", validarNome),
      cpf: new FormControl(representante?.cpf || "", validarCpf),
      emailPj: new FormControl(representante?.emailPj || "", validarEmail),
    });
  }

  adicionarEmpresa() {
    this.empresas.push(this.novaEmpresa());
  }

  removerEmpresa(i: number) {
    this.empresas.removeAt(i);
  }


  private validateFormEmpresa(): boolean {
    const cnpjs: string[] = [];

    const empresas = this.formEmpresa.get("empresas") as FormArray;

    for (let e = 0; e < empresas.length; e++) {
      const emp = empresas.at(e) as FormGroup;
      const cnpjValue = emp.get("cnpj")?.value;

      // Contêm os valores dos representates de uma determinada empresa.
      const nomes: string[] = [];
      const cpfs: string[] = [];
      const emails: string[] = [];

      // Validação de CNPJ

      let cnpjValido = cnpjValue;

      try {
        cnpjValido = CnpjValidator.create(cnpjValue);
        emp.get("cnpj")?.setValue(cnpjValido);
      } catch {
        showError("", `O CNPJ do Credor Pessoa Jurídica na posição ${e + 1} não é válido.`);
        return false;
      }

      if (cnpjs.includes(cnpjValido)) {
        showError("", `O CNPJ ${cnpj.format(cnpjValido)} está duplicado.`);
        return false;
      }

      cnpjs.push(cnpjValido);

      // Validação de Razão Social
      if (emp.get("nomeEmpresa")?.hasError("required")) {
        showError(
          "",
          `O campo Razão Social do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
        );
        return false;
      }

      if (emp.get("nomeEmpresa")?.hasError("pattern")) {
        showError(
          "",
          `O campo Razão Social do Credor Pessoa Jurídica ${e + 1} contém caracteres inválidos.`
        );
        return false;
      }

      const representantes = emp.get("representantes") as FormArray;
      const emailRegex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

      // Validação dos Representantes
      for (let i = 0; i < representantes.length; i++) {
        const rep = representantes.at(i) as FormGroup;
        const nome = rep.get("nome")?.value?.toLowerCase()?.trim();
        const cpfRep = rep.get("cpf")?.value?.trim();
        const emailPj = rep.get("emailPj")?.value?.toLowerCase()?.trim();

        if (i === 0) {
          if (!nome || nome.length === 0) {
            showError(
              "",
              `O nome do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
            );
            return false;
          }
          if (!cpfRep || cpfRep.length === 0 || !cpf.isValid(cpfRep)) {
            showError(
              "",
              `O CPF do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é inválido ou não foi preenchido.`
            );
            return false;
          }
          if (!emailPj || emailPj.length === 0) {
            showError(
              "",
              `O email do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
            );
            return false;
          }
        }

        if (emailPj && !emailRegex.test(emailPj)) {
          showError(
            "",
            `O email do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é inválido.`
          );
          return false;
        }

        if (cpfRep && !cpf.isValid(cpfRep)) {
          showError(
            "",
            `O CPF do Representante Legal na posição ${i + 1} do Credor Pessoa Jurídica ${
              e + 1
            } é inválido.`
          );
          return false;
        }

        if (cpfRep && cpfs.includes(cpfRep)) {
          showError(
            "",
            `O CPF do Representante Legal "${cpf.format(cpfRep)}" na posição ${
              i + 1
            } do Credor Pessoa Jurídica ${e + 1} está duplicado.`
          );
          return false;
        }

        if (cpfRep) cpfs.push(cpfRep);

        if (nome && nomes.includes(nome)) {
          showError(
            "",
            `O nome do Representante Legal "${nome}" na posição ${i + 1} do Credor Pessoa Jurídica ${
              e + 1
            } está duplicado.`
          );
          return false;
        }

        if (nome) nomes.push(nome);

        if (emailPj && emails.includes(emailPj)) {
          showError(
            "",
            `O email do Representante Legal "${emailPj}" na posição ${
              i + 1
            } do Credor Pessoa Jurídica ${e + 1} está duplicado.`
          );
          return false;
        }

        if (emailPj) emails.push(emailPj);
      }
    }

    return true;
  }

  private validateFormEntidade(): boolean {
    if (!safeAsign(this.tipoEntidade.value)) {
      showError(
        "Campo Obrigatório",
        "Selecione um tipo de entidade para prosseguir"
      );

      return false;
    }

    if (this.razaoSocial.hasError("required")) {
      showError("", `O campo Razão Social é obrigatório.`);
      return false;
    }

    if (this.razaoSocial.hasError("pattern")) {
      showError("", `O campo Razão Social contém caracteres inválidos.`);
      return false;
    }

    if (this.documentoIdentificadorCNPJ.hasError("cnpjInvalid")) {
      showError("", "Infome um CPF Válido.");
      return false;
    }

    if (this.formEntity.errors?.telOrCellRequired) {
      showError(
        "Telefone ou celular não informado",
        "para prosseguir informe um número de telefone ou de celular"
      );
      return false;
    }

    if (this.formEntity.invalid) {
      showError(
        "Campos obrigatórios não preenchidos corretamente.",
        "Campos obrigatórios não preenchidos corretamente. Revise o formulário novamente para prosseguir."
      );
      return false;
    }

    return true;
  }

  get tipoEntidade() {
    return this.formEntity.get("tipoEntidade");
  }

  get documentoIdentificadorCNPJ() {
    return this.formEntity.get("documentoIdentificador");
  }

  get razaoSocial() {
    return this.formEntity.get("razaoSocial");
  }
}
